import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/** Where a "Possible jobs" suggestion comes from (PD-17095, JQ-4). */
export const JOB_SUGGESTION_SOURCES = ['order_job', 'ship_to', 'contract'] as const;
export type JobSuggestionSource = (typeof JOB_SUGGESTION_SOURCES)[number];

/**
 * PD-17095 — a "Possible jobs" suggestion a rep dismissed, so it stays out of
 * the list. The key is the suggestion's identity within its source: the
 * lower-cased job name on the customer's orders (`order_job`), the ship-to's
 * address id (`ship_to`) or the price contract id (`contract`, no customer).
 * SM2-only.
 */
@Index('job_suggestion_dismissal__source_key', ['source', 'suggestionKey', 'fkClientId'], {})
@Entity('job_suggestion_dismissal')
export class JobSuggestionDismissalEntity extends BaseEntity {
	@Column('varchar', { name: 'source', length: 16 })
	public source!: JobSuggestionSource;

	@Column('varchar', { name: 'suggestionKey', length: 255 })
	public suggestionKey!: string;

	@Column('int', { name: 'fk_client__id', unsigned: true, nullable: true })
	public fkClientId!: number | null;
}
